import { render, staticRenderFns } from "./highwayStat.vue?vue&type=template&id=3aa1d38d&scoped=true&"
import script from "./highwayStat.vue?vue&type=script&lang=js&"
export * from "./highwayStat.vue?vue&type=script&lang=js&"
import style0 from "./highwayStat.vue?vue&type=style&index=0&id=3aa1d38d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa1d38d",
  null
  
)

export default component.exports